export const environment = {
  production: false,
  apiUrl: 'https://moj-api.intentio.co.za',
};
